export default __webpack_public_path__ + "static/media/notification_settings_bell.72891ed4.svg";